import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
interface PositionManagerDepositDialogLoadingProps {
  /** Hold the space of the "Pay with" row a wNative vault shows under the input. */
  reservesWrapRow?: boolean;
}
const PositionManagerDepositDialogLoading = t0 => {
  const $ = _c(9);
  const {
    reservesWrapRow
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="gap-xs flex flex-col"><div className="flex flex-row justify-between"><Skeleton className="h-[26px] w-[170px] rounded-[20px]" /><Skeleton className="h-[26px] w-20 rounded-[20px]" /></div><Skeleton className="h-[87px] w-[100%] rounded-[20px]" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== reservesWrapRow) {
    t2 = reservesWrapRow && <div className="mt-xs h-[28px]" />;
    $[1] = reservesWrapRow;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="gap-2xs flex flex-col">{t1}{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Skeleton className="h-[184px] w-[100%] rounded-[20px]" />;
    t5 = <Skeleton className="h-[48px] w-[100%] rounded-lg" />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3) {
    t6 = <div className="gap-md flex flex-col">{t3}{t4}{t5}</div>;
    $[7] = t3;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export default PositionManagerDepositDialogLoading;